import { Dic } from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '140px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: i18n.t('personAccess.title.noData'),
    menu: false,
    column: [
      {
        label: '建筑名称',
        prop: 'coldStorageName',
        span: 12
      },
      {
        label: '日期',
        prop: 'date',
        search: true,
        type: 'daterange',
        valueFormat: 'yyyy-MM-dd',
        hide: true
      },
      {
        label: '风机名称',
        prop: 'ioPortName',
        search: true
      },

      {
        label: '当前运行状态',
        prop: 'normalValue',
        formatter: function (row, value) {
          if (value == 0) {
            return '停止'
          } else if (value == 1) {
            return '运行'
          } else {
            return '故障'
          }
        },
        span: 12
      },
      {
        label: '运行时长(分钟/min)',
        prop: 'runTimeLength',
        span: 12
      },
      {
        label: '故障时长(分钟/min)',
        prop: 'faultTimeLength',
        span: 12
      }
    ]
  }
}
export default tableOption
